import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// وارد کردن DateTimePicker به جای DatePicker
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';
import { Dialog, DialogContent, DialogTitle, Stack } from '@mui/material';
import ResponsiveDialogActions from './ResponsiveDialogAction';

export default function HistoryDateDialog({ open, onClose, onConfirm }) {
  // تاریخ و زمان فعلی به عنوان مقدار پیش‌فرض
  const [toDate, setToDate] = React.useState(new Date());

  const handleConfirm = () => {
    if (toDate) {
      // ارسال دقیق زمان و تاریخ انتخاب شده
      onConfirm(toDate);
    }
  };

  const modernInputSx = {
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: '#F8FAFC', // Light subtle background
      minHeight: '52px',
      transition: 'all 0.2s ease-in-out',
      '& fieldset': {
        borderColor: '#E2E8F0', // Clean default border
        borderWidth: '1px',
      },
      '&:hover': {
        backgroundColor: '#F1F5F9',
      },
      '&:hover fieldset': {
        borderColor: '#CBD5E1',
      },
      '&.Mui-focused': {
        backgroundColor: '#FFFFFF',
        boxShadow: '0 0 0 4px rgba(59, 130, 246, 0.12)', // Modern focus ring
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3B82F6',
        borderWidth: '1px',
      },
    },
    // Ensure the label color transitions smoothly
    '& .MuiInputLabel-root': {
      color: '#64748B',
      fontWeight: 500,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#3B82F6',
    },
    // Fixes for autocomplete inner paddings
    '& .MuiAutocomplete-inputRoot': {
      padding: '6px 12px !important',
      gap: '6px',
    },
  };
  const persianFontFamily =
    '"Vazirmatn", "IRANSans", "Yekan Bakh", "Tahoma", sans-serif';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth dir="rtl">
      <DialogTitle
        sx={{ fontWeight: 800, fontSize: '1.1rem', color: '#0f172a' }}
      >
        موجودی خزانه در تاریخ خاص
      </DialogTitle>
      <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 1 }}>
            <DateTimePicker
              label="تا تاریخ و ساعت"
              value={toDate}
              onChange={newValue => setToDate(newValue)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: 'small',
                  sx: modernInputSx,
                },
                popper: {
                  sx: {
                    direction: 'rtl',
                    // --- تنظیمات دکمه‌های ماه قبل و بعد ---
                    '& .MuiPickersCalendarHeader-labelContainer': {
                      marginRight: 0,
                      marginLeft: 'auto',
                    },
                    '& .MuiPickersArrowSwitcher-root': {
                      direction: 'rtl',
                    },
                    '& .MuiPickersArrowSwitcher-root .MuiIconButton-root': {
                      transform: 'rotate(180deg)',
                    },
                    '& .MuiPickersLayout-root': {
                      direction: 'rtl',
                    },
                    // '& *': {
                    //   fontFamily: `${persianFontFamily} !important`,
                    // },
                  },
                },
              }}
            />
          </Stack>

          <ResponsiveDialogActions
            onAccept={handleConfirm}
            onReject={onClose}
            acceptText={'تایید'}
            rejectText={'انصراف'}
            acceptButtonProps={{
              sx: {
                py: 1.2,
                borderRadius: '12px',
                color: '#fff',
                fontWeight: 700,
                fontSize: '0.95rem',
                boxShadow: '0 6px 16px rgba(37, 99, 235, 0.2)',
                backgroundColor: '#2563eb',
                '&:hover': {
                  backgroundColor: '#1d4ed8',
                  boxShadow: '0 8px 20px rgba(37, 99, 235, 0.3)',
                },
              },
            }}
            rejectButtonProps={{
              sx: {
                py: 1.2,
                borderRadius: '12px',
                color: '#64748B',
                fontWeight: 700,
                fontSize: '0.95rem',
                backgroundColor: '#F1F5F9',
                '&:hover': {
                  backgroundColor: '#FEE2E2',
                  color: '#E11D48',
                },
              },
            }}
          />
        </DialogContent>
      </LocalizationProvider>
    </Dialog>
  );
}
